// src/components/admin/AdminInvitaciones.js
import React, { useState, useEffect } from 'react';
import { crearInvitacion, listarInvitaciones, eliminarInvitacion, reenviarInvitacion } from '../../services/api';

const AdminInvitaciones = () => {
  const [invitaciones, setInvitaciones] = useState([]);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ type: '', text: '' });

  useEffect(() => {
    cargarInvitaciones();
  }, []);

  const cargarInvitaciones = async () => {
    try {
      const response = await listarInvitaciones();
      setInvitaciones(response.data.invitaciones || []);
    } catch (error) {
      console.error('Error cargando invitaciones:', error);
      setMensaje({ type: 'error', text: 'Error al cargar invitaciones' });
    }
  };

  const handleCrearInvitacion = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setMensaje({ type: '', text: '' });

    try {
      const response = await crearInvitacion(email);
      setMensaje({ 
        type: 'success', 
        text: `✅ Invitación creada para ${email}` 
      });
      setEmail('');
      cargarInvitaciones();
    } catch (error) {
      setMensaje({ 
        type: 'error', 
        text: error.response?.data?.error || 'Error al crear invitación' 
      });
    } finally {
      setLoading(false);
    }
  };

  const copiarToken = (token) => {
    navigator.clipboard.writeText(token);
    setMensaje({ type: 'success', text: '✅ Token copiado al portapapeles' });
    setTimeout(() => setMensaje({ type: '', text: '' }), 3000);
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar esta invitación?')) return;
    
    try {
      await eliminarInvitacion(id);
      setMensaje({ type: 'success', text: '✅ Invitación eliminada' });
      cargarInvitaciones();
    } catch (error) {
      setMensaje({ 
        type: 'error', 
        text: error.response?.data?.error || 'Error al eliminar' 
      });
    }
  };

  const handleReenviar = async (id, email) => {
    try {
      await reenviarInvitacion(id);
      setMensaje({ type: 'success', text: `✅ Invitación reenviada a ${email}` });
    } catch (error) {
      setMensaje({ 
        type: 'error', 
        text: error.response?.data?.error || 'Error al reenviar' 
      });
    }
  };

  const formatFecha = (fechaString) => {
    if (!fechaString) return 'N/A';
    try {
      const fecha = new Date(fechaString);
      if (isNaN(fecha.getTime())) return 'Fecha inválida';
      return fecha.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return 'Fecha inválida';
    }
  };

  return (
    <div className="admin-invitaciones">
      <h2>📨 Invitaciones para Beta Testers</h2>
      
      <div className="crear-invitacion">
        <h3>Crear nueva invitación</h3>
        <form onSubmit={handleCrearInvitacion}>
          <div className="form-group">
            <label>Email del betatester:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ejemplo@email.com"
              required
            />
          </div>
          <button type="submit" disabled={loading} className="btn-crear">
            {loading ? 'Creando...' : 'Crear invitación'}
          </button>
        </form>

        {mensaje.text && (
          <div className={`mensaje ${mensaje.type}`}>
            {mensaje.text}
          </div>
        )}
      </div>

      <div className="lista-invitaciones">
        <h3>Invitaciones enviadas</h3>
        <div className="table-responsive">
          <table className="tabla-invitaciones">
            <thead>
              <tr>
                <th>Email</th>
                <th>Token</th>
                <th>Estado</th>
                <th>Creada</th>
                <th>Expira</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {invitaciones.map(inv => (
                <tr key={inv.id}>
                  <td>{inv.email}</td>
                  <td className="token-cell">
                    <code className="token-text">{inv.token}</code>
                    <button 
                      onClick={() => copiarToken(inv.token)}
                      className="btn-copiar-icon"
                      title="Copiar token"
                    >
                      📋
                    </button>
                  </td>
                  <td>
                    <span className={`estado ${inv.usado ? 'usada' : 'pendiente'}`}>
                      {inv.usado ? '✓ Usada' : '⏳ Pendiente'}
                    </span>
                  </td>
                  <td>{formatFecha(inv.creada_en)}</td>
                  <td>{formatFecha(inv.expira_en)}</td>
                  <td>
                    <div className="acciones-cell">
                      {!inv.usado && (
                        <>
                          <button 
                            onClick={() => handleReenviar(inv.id, inv.email)}
                            className="btn-accion btn-reenviar"
                            title="Reenviar invitación"
                          >
                            📧
                          </button>
                          <button 
                            onClick={() => handleEliminar(inv.id)}
                            className="btn-accion btn-eliminar"
                            title="Eliminar invitación"
                          >
                            🗑️
                          </button>
                        </>
                      )}
                      {inv.usado && (
                        <span className="usado-label">-</span>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {invitaciones.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">
                    No hay invitaciones creadas aún
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminInvitaciones;